/**
 * @generated SignedSource<<6ff798480a98c62e6a0b789db056fe77>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DefaultRendering_toolCalls$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"ToolCallButton_toolCall" | "ToolCallSheet_toolCall">;
  readonly " $fragmentType": "DefaultRendering_toolCalls";
}>;
export type DefaultRendering_toolCalls$key = ReadonlyArray<{
  readonly " $data"?: DefaultRendering_toolCalls$data;
  readonly " $fragmentSpreads": FragmentRefs<"DefaultRendering_toolCalls">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "DefaultRendering_toolCalls",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ToolCallButton_toolCall"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ToolCallSheet_toolCall"
    }
  ],
  "type": "GraphQLMessageToolCall",
  "abstractKey": null
};

(node as any).hash = "5f3a68958af75bdf18b46e5c4750d4dd";

export default node;
